import { Injectable } from '@angular/core';
import {
  throwError as observableThrowError,
  Observable,
  of as observableOf,
} from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';
import { IBanners } from '../interfaces/banners';
import { IBanner } from '../interfaces/banner';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BannerRotativeService {
  constructor(private _apiService: ApiService) {}

  list(): Observable<IBanners> {
    return this._apiService.doGET('banner-rotative?local=RT').pipe(
      catchError((err) => {
        return observableThrowError(err.error_message);
      })
    );
  }

  show(id: number): Observable<IBanner> {
    return this._apiService.doGET('banner-rotative/' + id).pipe(
      catchError((err) => {
        return observableThrowError(err.error_message);
      })
    );
  }

  store(data): Observable<any> {
    return this._apiService.doPOST('banner-rotative', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  patch(idbanner, data): Observable<any> {
    return this._apiService.doPATCH('banner-rotative/' + idbanner, data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  patchOrdem(data): Observable<any> {
    return this._apiService.doPATCH('banner-rotative/ordem', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  delete(idbanner): Observable<any> {
    return this._apiService.doDELETE('banner-rotative/' + idbanner).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  removeImage(idbanner, tipo): Observable<any> {
    return this._apiService
      .doDELETE('banner-rotative/' + idbanner + '/image?tipo=' + tipo)
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }
}
